import uniqueId from 'lodash/uniqueId';
import { ClientDataType } from 'modules/queryBuilder/types';
import { RequirementLayoutProps } from 'modules/queryBuilder/contexts';
import { ConditionActionButtons } from '../ConditionLayout/ConditionLayout.styles';
import {
  ActionButtonWrapper,
  ConditionWrapper,
  ConditionRow,
  FirstRow,
  FirstWrapper,
  MainRow,
  Pretext,
} from './RequirementLayout.styles';
import {
  MINIMUM_USER_CONDITIONS_FOR_COMBINATOR,
  MINIMUM_EVENT_CONDITIONS_FOR_COMBINATOR,
} from './constants';
import { useGetAdditionalConditionPretext } from './useGetAdditionalConditionPretext';
import { useRequirementPretext } from './hooks/useRequirementPretext';
import { REQUIREMENT_LAYOUT_DATA_TEST } from './constants';

export const RequirementLayout = ({
  dataType,
  isCatalogESIndex = false,
  combinator,
  Conditions,
  Add,
  Delete,
  Duplicate,
  EventSelect,
  CountFilter,
  CombinatorSelect,
}: RequirementLayoutProps) => {
  const requirementPretext = useRequirementPretext(dataType, isCatalogESIndex);
  const getAdditionalConditionPretext = useGetAdditionalConditionPretext();
  const isUserEvent = dataType === ClientDataType.User;
  const [FirstCondition, ...RemainingConditions] = Conditions;
  const minimumConditionsForCombinator = isUserEvent
    ? MINIMUM_USER_CONDITIONS_FOR_COMBINATOR
    : MINIMUM_EVENT_CONDITIONS_FOR_COMBINATOR;
  const isCombinatorSelectVisible = Conditions.length >= minimumConditionsForCombinator;
  return (
    <MainRow data-test={REQUIREMENT_LAYOUT_DATA_TEST.requirementRow}>
      <FirstRow data-test={REQUIREMENT_LAYOUT_DATA_TEST.initialConditionRow}>
        <FirstWrapper>
          <Pretext data-first>{requirementPretext}</Pretext>
          {isUserEvent && FirstCondition}
          {!isUserEvent && !!EventSelect && EventSelect}
          {!isUserEvent && !!CountFilter && CountFilter}
          {isCombinatorSelectVisible && !!CombinatorSelect && CombinatorSelect}
          {!!Add && (
            <ConditionActionButtons data-test={REQUIREMENT_LAYOUT_DATA_TEST.conditionActionButtons}>
              {Add}
            </ConditionActionButtons>
          )}
        </FirstWrapper>
        <ActionButtonWrapper
          id={REQUIREMENT_LAYOUT_DATA_TEST.actionButtons}
          data-test={REQUIREMENT_LAYOUT_DATA_TEST.actionButtons}
        >
          {Duplicate}
          {Delete}
        </ActionButtonWrapper>
      </FirstRow>
      {(isUserEvent ? RemainingConditions : Conditions).map((Condition, i) => {
        const additionalConditionPretext = getAdditionalConditionPretext(
          i,
          combinator,
          isUserEvent,
        );
        return (
          <ConditionWrapper
            key={uniqueId()}
            data-test={REQUIREMENT_LAYOUT_DATA_TEST.subconditionRow}
          >
            <Pretext>{additionalConditionPretext}</Pretext>
            <ConditionRow>{Condition}</ConditionRow>
          </ConditionWrapper>
        );
      })}
    </MainRow>
  );
};
